export const CHECK_TYPES = {
  CHECKED: 'checked',
  UNCHECKED: 'unchecked',
  INDETERMINATE: 'indeterminate',
} as const;

export const DATA_CHECK_TYPE = 'data-check-type';
export const DATA_HAS_ERROR = 'data-has-error';
export const DATA_DISABLED = 'data-disabled';
